import Link from "next/link";
import { LinkGroup as LinkGroupType } from "./types";
import { trackMegaMenuLinkClick } from "@/utils/analytics";

interface LinkGroupProps {
  group: LinkGroupType;
  menuId: string;
  groupId: string;
}

export default function LinkGroup({ group, menuId, groupId }: LinkGroupProps) {
  const headingId = `${menuId}-${groupId}-heading`;

  return (
    <div className="relative">
      {group.headingUrl ? (
        <Link
          href={group.headingUrl}
          id={headingId}
          className="inline-block font-bold text-gray-900 hover:text-brand-600 transition-colors duration-200 text-base mb-5 relative group/heading cursor-pointer"
          onClick={() => {
            trackMegaMenuLinkClick({
              menu: menuId,
              linkText: group.heading,
              linkUrl: group.headingUrl || "",
            });
          }}
        >
          {group.heading}
          <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-brand-600 transition-all duration-200 group-hover/heading:w-full" />
        </Link>
      ) : (
        <p id={headingId} className="font-bold text-gray-900 text-base mb-5">
          {group.heading}
        </p>
      )}
      {group.items.length > 0 && (
        <ul role="list" aria-labelledby={headingId} className="space-y-3">
          {group.items.map((item, index) => {
            const { url, label, badge, ...rest } = item;
            return (
              <li key={index} className="group/item">
                <Link
                  href={url}
                  className="flex items-center text-sm text-gray-600 hover:text-brand-600 transition-all duration-200 leading-relaxed font-medium"
                  onClick={() => {
                    trackMegaMenuLinkClick({
                      menu: menuId,
                      linkText: label,
                      linkUrl: url,
                    });
                  }}
                  {...rest}
                >
                  <span className="opacity-0 w-0 group-hover/item:opacity-100 group-hover/item:w-4 group-hover/item:mr-1 text-brand-600 transition-all duration-200 flex-shrink-0">
                    &gt;
                  </span>
                  <span className="group-hover/item:ml-0 ml-0 transition-all duration-200">
                    {label}
                  </span>
                  {badge && (
                    <span className="ml-1 rounded-full bg-brand-600 px-2 py-0.5 text-xs font-semibold text-white">
                      {badge}
                    </span>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
